
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_1y9t1_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_1y9t1_14",
  "token-field-container": "awsui_token-field-container_vm8qf_1y9t1_18",
  "token-field": "awsui_token-field_vm8qf_1y9t1_18",
  "token-field-disabled": "awsui_token-field-disabled_vm8qf_1y9t1_54",
  "token-field-readonly": "awsui_token-field-readonly_vm8qf_1y9t1_62",
  "token-field-invalid": "awsui_token-field-invalid_vm8qf_1y9t1_68",
  "token-field-warning": "awsui_token-field-warning_vm8qf_1y9t1_80",
  "grouped": "awsui_grouped_vm8qf_1y9t1_92",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_1y9t1_98",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_1y9t1_102",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_1y9t1_108",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_1y9t1_112",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_1y9t1_116",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_1y9t1_122",
  "grouped-with-action": "awsui_grouped-with-action_vm8qf_1y9t1_126",
  "token-field-icon": "awsui_token-field-icon_vm8qf_1y9t1_131",
  "token-list": "awsui_token-list_vm8qf_1y9t1_137",
  "inline-tokens": "awsui_inline-tokens_vm8qf_1y9t1_151",
  "token-list-item": "awsui_token-list-item_vm8qf_1y9t1_155",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_1y9t1_159",
  "token-overflow": "awsui_token-overflow_vm8qf_1y9t1_166",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_1y9t1_170",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_1y9t1_174",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_1y9t1_183",
  "measurement-container": "awsui_measurement-container_vm8qf_1y9t1_189",
  "measurement-token": "awsui_measurement-token_vm8qf_1y9t1_202"
};
  